import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: [
        ['poolEdge', 0.55],
        ['poolWater', 0.45],
      ],
      d: 'M-2,-1.5h0.5v0.5h-0.5zM-1,-1.5h0.5v0.5h-0.5zM-3,-1h0.5v0.5h-0.5zM0.5,-1h0.5v0.5h-0.5zM-3.5,-0.5h0.5v0.5h-0.5zM-2.5,-0.5h0.5v0.5h-0.5zM2,-0.5h1v0.5h-1zM-3.5,0h1v0.5h-1zM-1,0h0.5v0.5h-0.5zM2,0h0.5v0.5h-0.5zM-3,0.5h2v0.5h-2zM0.5,0.5h0.5v0.5h-0.5zM1.5,0.5h0.5v0.5h-0.5zM2.5,0.5h1v0.5h-1zM-2,1h3v0.5h-3zM1.5,1h2v0.5h-2zM-0.5,1.5h3v0.5h-3zM1,2h0.5v0.5h-0.5z',
    },
    {
      paint: 'poolEdge',
      d: 'M-2,-2h2.5v0.5h-2.5zM-3,-1.5h1v0.5h-1zM-0.5,-1.5h2.5v0.5h-2.5zM-3.5,-1h0.5v0.5h-0.5zM1,-1h2.5v0.5h-2.5zM-3,-0.5h0.5v0.5h-0.5zM3,-0.5h1v0.5h-1zM-2.5,0h1.5v0.5h-1.5zM2.5,0h1v0.5h-1zM-1,0.5h1.5v0.5h-1.5zM2,0.5h0.5v0.5h-0.5zM1,1h0.5v0.5h-0.5z',
    },
    { paint: 'poolWater', d: 'M-1,-1h1.5v0.5h-1.5zM0.5,-0.5h1.5v0.5h-1.5z' },
    {
      paint: [
        ['poolWater', 0.7],
        ['waterLight', 0.3],
      ],
      d: 'M-1.5,-1.5h0.5v0.5h-0.5zM-2.5,-1h1.5v0.5h-1.5zM-2,-0.5h2.5v0.5h-2.5zM-0.5,0h2.5v0.5h-2.5zM1,0.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 89,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: [
        ['poolEdge', 0.55],
        ['poolWater', 0.45],
      ],
      d: 'M-2,-1.5h0.5v0.5h-0.5zM-1,-1.5h0.5v0.5h-0.5zM-3,-1h0.5v0.5h-0.5zM0,-1h1.5v0.5h-1.5zM-4,-0.5h0.5v0.5h-0.5zM-2.5,-0.5h0.5v0.5h-0.5zM2,-0.5h1v0.5h-1zM-3.5,0h1v0.5h-1zM-1,0h0.5v0.5h-0.5zM2,0h0.5v0.5h-0.5zM-3,0.5h2v0.5h-2zM0.5,0.5h0.5v0.5h-0.5zM1.5,0.5h0.5v0.5h-0.5zM2.5,0.5h1v0.5h-1zM-2,1h3v0.5h-3zM1.5,1h2v0.5h-2zM-0.5,1.5h3v0.5h-3zM1,2h0.5v0.5h-0.5z',
    },
    {
      paint: 'poolEdge',
      d: 'M-2,-2h2.5v0.5h-2.5zM-3,-1.5h1v0.5h-1zM-0.5,-1.5h2.5v0.5h-2.5zM-3.5,-1h0.5v0.5h-0.5zM1.5,-1h2v0.5h-2zM-3.5,-0.5h1v0.5h-1zM3,-0.5h1v0.5h-1zM-2.5,0h1.5v0.5h-1.5zM2.5,0h1v0.5h-1zM-1,0.5h1.5v0.5h-1.5zM2,0.5h0.5v0.5h-0.5zM1,1h0.5v0.5h-0.5z',
    },
    { paint: 'poolWater', d: 'M-1,-1h1v0.5h-1zM1.5,-0.5h0.5v0.5h-0.5z' },
    {
      paint: [
        ['poolWater', 0.7],
        ['waterLight', 0.3],
      ],
      d: 'M-1.5,-1.5h0.5v0.5h-0.5zM-2.5,-1h1.5v0.5h-1.5zM-2,-0.5h1.5v0.5h-1.5zM-0.5,0h2.5v0.5h-2.5zM1,0.5h0.5v0.5h-0.5z',
    },
    { paint: 'parasolYellow', d: 'M-0.5,-0.5h2v0.5h-2z' },
  ],
  pixels: 90,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: [
        ['poolEdge', 0.55],
        ['poolWater', 0.45],
      ],
      d: 'M-2,-1.5h0.5v0.5h-0.5zM-1,-1.5h0.5v0.5h-0.5zM-3,-1h0.5v0.5h-0.5zM0.5,-1h0.5v0.5h-0.5zM1.5,-1h0.5v0.5h-0.5zM-4,-0.5h0.5v0.5h-0.5zM-2.5,-0.5h0.5v0.5h-0.5zM2,-0.5h1v0.5h-1zM-3.5,0h1v0.5h-1zM-1,0h0.5v0.5h-0.5zM2,0h0.5v0.5h-0.5zM-3,0.5h2v0.5h-2zM0.5,0.5h0.5v0.5h-0.5zM1.5,0.5h0.5v0.5h-0.5zM2.5,0.5h1v0.5h-1zM-2,1h3v0.5h-3zM1.5,1h2v0.5h-2zM-0.5,1.5h3v0.5h-3zM1,2h0.5v0.5h-0.5z',
    },
    {
      paint: 'poolEdge',
      d: 'M-2,-2h2.5v0.5h-2.5zM-3,-1.5h1v0.5h-1zM-0.5,-1.5h2v0.5h-2zM-3.5,-1h0.5v0.5h-0.5zM1,-1h0.5v0.5h-0.5zM2,-1h1.5v0.5h-1.5zM-3.5,-0.5h1v0.5h-1zM3,-0.5h1v0.5h-1zM-2.5,0h1.5v0.5h-1.5zM2.5,0h1v0.5h-1zM-1,0.5h1.5v0.5h-1.5zM2,0.5h0.5v0.5h-0.5zM1,1h0.5v0.5h-0.5z',
    },
    { paint: 'poolWater', d: 'M-1,-1h1.5v0.5h-1.5zM0.5,-0.5h1.5v0.5h-1.5z' },
    {
      paint: [
        ['poolWater', 0.7],
        ['waterLight', 0.3],
      ],
      d: 'M-1.5,-1.5h0.5v0.5h-0.5zM-2.5,-1h1.5v0.5h-1.5zM-2,-0.5h2.5v0.5h-2.5zM-0.5,0h2.5v0.5h-2.5zM1,0.5h0.5v0.5h-0.5z',
    },
    { paint: 'sprinklerMetal', d: 'M2.5,-2.5h0.5v0.5h-0.5zM1.5,-2h2v1h-2z' },
  ],
  pixels: 98,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
